import TodoVMApp from "./todo-vm.ssr.tsx";
TodoVMApp.mount();
